import { requestOptions } from './requests/request-options';
import { entities } from './entities';
export const factory = {
  entities,
  requestOptions
};
//# sourceMappingURL=index.js.map